export default {
  app_name: 'Suitup',
  website: 'https://www.suitup.co.il',
  finance_email: 'finance@suitup.co.il',
  phone_number: '03-7767762'
}
